module.exports = __webpack_public_path__ + "img/workBench2.85c1be85.png";